module.exports = __webpack_public_path__ + "b8059614c692b1fe9c3b5970f71c3932.svg";